import React from "react";
import { motion } from "framer-motion";

const HumanBillerSlide = () => {
  return (
    <div className="h-full w-full bg-[#0f172a] text-white flex items-center justify-center p-12 relative overflow-hidden">
        {/* Background Gradients */}
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-blue-900/20 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-[800px] h-[800px] bg-indigo-900/20 rounded-full blur-[120px] translate-y-1/2 -translate-x-1/2" />
        
        {/* Curved Line Decoration */}
         <svg className="absolute top-0 right-0 h-[120%] w-[60%] pointer-events-none opacity-50" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M100 0 C 60 40, 40 80, 0 100" stroke="#8b5cf6" strokeWidth="0.5" fill="none" />
            <path d="M100 10 C 70 50, 50 90, 10 110" stroke="#6366f1" strokeWidth="0.5" fill="none" className="opacity-50" />
         </svg>

        <div className="flex flex-row h-full w-full max-w-[1400px] gap-12 items-center relative z-10 pt-0">
            {/* Left Side: Content */}
            <div className="w-1/2 space-y-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >

                    <h2 className="text-4xl lg:text-5xl font-bold leading-tight mb-4">
                        In addition to AI, we assign your practice a <span className="text-blue-400">dental billing expert</span>.
                    </h2>
                    <p className="text-lg text-blue-200/60 font-light">Available in select plans</p>
                </motion.div>

                <div className="space-y-10">
                    {/* Item 1 */}
                    <motion.div 
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                        className="space-y-3"
                    >
                        <h3 className="text-2xl font-bold text-white">Based in the US</h3>
                        <p className="text-xl text-blue-200/80 leading-relaxed font-light">
                            Your practice deserves a local touch from someone who understands context and is easy to work with.
                        </p>
                    </motion.div>

                    {/* Item 2 */}
                    <motion.div 
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                        className="space-y-3"
                    >
                        <h3 className="text-2xl font-bold text-white">Specially trained to use our AI</h3>
                        <p className="text-xl text-blue-200/80 leading-relaxed font-light">
                            Has achieved certification in leveraging Asha's AI tools to maximize collections.
                        </p>
                    </motion.div>

                    {/* Item 3 */}
                    <motion.div 
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.7, duration: 0.5 }}
                        className="space-y-3"
                    >
                        <h3 className="text-2xl font-bold text-white">Experienced in full dental RCM</h3>
                        <p className="text-xl text-blue-200/80 leading-relaxed font-light">
                            Insurance verification, claim submission, denial management, managing AR, and more.
                        </p>
                    </motion.div>
                </div>
            </div>

            {/* Right Side: Image */}
             <motion.div 
                className="w-1/2 h-full flex items-center justify-center relative"
                initial={{ opacity: 0, scale: 0.95, x: 20 }}
                whileInView={{ opacity: 1, scale: 1, x: 0 }}
                transition={{ duration: 0.8 }}
            >
                <div className="relative h-[90%] w-full rounded-3xl overflow-hidden shadow-2xl border border-white/10 group">
                    <img 
                        src="/assets/humanbiller.png" 
                        alt="Dental Billing Expert" 
                        className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700"
                    />
                     {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-transparent to-transparent opacity-20"></div>
                </div>
            </motion.div>
        </div>
    </div>
  );
};

export default HumanBillerSlide;
